import { APersonal } from "../api";
import {
  showLoading,
  setQuotation,
} from "../actions";

export function getQuotation() {
  return function func(dispatch, getState) {

    const { quoter } = getState().options;
    const { occupation } = getState().client;

    const request = {
      broker: '',
      occupationId: parseInt(occupation.value, 0)
    };
    
    dispatch(showLoading(true));

    return APersonal.getQuotation(request).then(response => {
      if (response) {
        dispatch(setQuotation(quoter, response));
      } else {
        dispatch(setQuotation(quoter, { respuesta: { mensaje: 'Error al obtener la cotización' }}));
      }
      dispatch(showLoading(false));
    });
  };
}